import './Testimonials.css';

// ⚠️ Placeholder testimonials — replace with real client quotes before going live
const testimonials = [
  {
    quote: 'Our footfall doubled within 3 months. The Meta ads AerialRoot ran for us reached exactly the customers we wanted — no wasted budget.',
    name: 'Client Name',
    role: 'Owner, Restaurant Brand · Trichy',
    initials: 'CN',
    delay: 'd1',
  },
  {
    quote: 'They rebuilt our website and set up WhatsApp automation. Leads now come in every day and we respond instantly, even after hours.',
    name: 'Client Name',
    role: 'Founder, Retail Business · Chennai',
    initials: 'CN',
    delay: 'd2',
  },
  {
    quote: 'What impressed us most is the transparency. Every rupee spent is tracked in a dashboard, and the monthly reports are crystal clear.',
    name: 'Client Name',
    role: 'Director, Education Institute · Madurai',
    initials: 'CN',
    delay: 'd3',
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="tsm-section">
      <div className="tsm-header reveal">
        <span className="section-label">Client Love</span>
        <h2 className="section-title">What Our <em>Clients Say</em></h2>
        <p className="section-sub">Businesses across Tamil Nadu trust us with their growth. Here's why.</p>
      </div>
      <div className="tsm-grid">
        {testimonials.map(t => (
          <figure key={t.role} className={`tsm-card reveal-scale ${t.delay}`}>
            <span className="tsm-quote-mark">"</span>
            <blockquote>{t.quote}</blockquote>
            <figcaption>
              <span className="tsm-avatar">{t.initials}</span>
              <span>
                <strong>{t.name}</strong>
                <small>{t.role}</small>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
